// @ts-nocheck

/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/axios";
import type { ScheduleNotificationDemoNotifyPostMutationRequest, ScheduleNotificationDemoNotifyPostMutationResponse, ScheduleNotificationDemoNotifyPost422 } from "../models/demoController/ScheduleNotificationDemoNotifyPost.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/axios";

function getScheduleNotificationDemoNotifyPostUrl() {
  const res = { method: 'POST', url: `/demo/notify` as const }
  return res
}

/**
 * @description Schedule a delayed Telegram notification for demo.
 * Requires Telegram authentication (guest users not supported).
 * Args:
 * delay_seconds: Delay before sending (1-60 seconds)
 * @summary Schedule Notification
 * {@link /demo/notify}
 */
export async function scheduleNotificationDemoNotifyPost(data: ScheduleNotificationDemoNotifyPostMutationRequest, config: Partial<RequestConfig<ScheduleNotificationDemoNotifyPostMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ScheduleNotificationDemoNotifyPostMutationResponse, ResponseErrorConfig<ScheduleNotificationDemoNotifyPost422>, ScheduleNotificationDemoNotifyPostMutationRequest>({ method : "POST", url : getScheduleNotificationDemoNotifyPostUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}